import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiFormLabel: MuiComponent<"MuiFormLabel"> = {
  styleOverrides: {
    root: {
      color: Colors.LightGray,
      fontSize: '14px',
    },
  },
}

export const MuiInputLabel: MuiComponent<"MuiInputLabel"> = {
  styleOverrides: {
    root: {
      color: Colors.LightGray,
      fontSize: '14px',
    },
    shrink: {
      transform: 'translate(14px, -10px) scale(1) !important',
    },
    outlined: {
      transform: 'translate(14px, 14px) scale(1)',
    },
  },
}